import './footer.scss'
import { useI18n } from '@vista-digital/occ-ui'
import { observer } from 'mobx-react-lite'
import type { FC } from 'react'
import { useB2BHeaderAndFooterData } from '@/common/hooks/useB2BHeaderAndFooterData'
import { useLoadingProvider } from '@/common/providers/loadingProvider'
import { Logo } from '../../../common/components/logo'
import { cmsDataService } from '../../services/cms.data.service'
import { navigationService } from '../../services/navigation.service'
import { SecondaryFooter } from '../secondaryFooter/SecondaryFooter'
import { FooterLinks } from './subcomponents/FooterLinks'
import { FooterSocials } from './subcomponents/FooterSocials'

export const Footer: FC = observer(() => {
    const b2bHeaderAndFooterData = useB2BHeaderAndFooterData()
    const { isPageLoading } = useLoadingProvider()

    const footerCmsData = b2bHeaderAndFooterData ? b2bHeaderAndFooterData.footer : cmsDataService.get().footer
    const secondaryFooterCmsData = cmsDataService.get().secondaryFooter
    const currentYear = new Date().getFullYear()
    const { template } = useI18n()

    const page = navigationService.getCurrentPage()

    const HomePageClass = page === 'Home' ? 'home-page' : ''

    if (page === 'B2BDelegateWifi' || page === 'B2BDelegateWifiConnected') {
        return null
    }

    return (
        <footer className={` ${isPageLoading ? 'footer-hidden' : 'footer-visible'}`}>
            {secondaryFooterCmsData?.displaySecondaryFooter && !b2bHeaderAndFooterData && (
                <SecondaryFooter {...secondaryFooterCmsData} />
            )}
            <div className={`footer ${HomePageClass}`}>
                <FooterLinks {...footerCmsData} />
                <div className="footer-logo-box">
                    <Logo />
                </div>
                <div className="footer--copyrights__wrapper">
                    <div className="full-width no-padding footer--copyrights__container container-lg-padding">
                        <div className="row footer--copyrights__grid">
                            <FooterSocials {...footerCmsData} />

                            <div className="copyrights--box text-box">
                                {footerCmsData.copyrightText && (
                                    <p>{template(footerCmsData.copyrightText, { currentYear })}</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
})
